<template>
  <v-container grid-list-xl fluid fill-height>
    <v-layout wrap align-center justify-center>

      <v-card class="mx-auto" width="100%" max-width="500" flat>
        <!-- <v-tabs
          v-model="tab"
          active-class='primary white--text'
          background-color="grey lighten-4"
          grow>
          <v-tabs-slider />

          <v-tab>
            Registrarte como restaurantero
          </v-tab>
          <v-tab>
            Registrarte como proveedor
          </v-tab>
        </v-tabs> -->

        <!-- <v-tabs-items v-model="tab">
          <v-tab-item> -->
           <v-card flat v-if="isProvider">
              <v-card-title>{{ $t('auth.createAccountType', {type: $t('auth.provider')}) }}</v-card-title>
              <v-card-text>
                <v-row>
                  <v-col>
                    <v-form v-model="isValid">
                      <v-row>
                        <v-col>
                          <v-text-field
                            data-cy="firstName-provider"
                            v-model="form.firstName"
                            :rules="rules.firstName"
                            :label="$t('auth.labels.firstName')"
                            required
                          />
                        </v-col>
                        <v-col>
                          <v-text-field
                            data-cy="lastName-provider"
                            v-model="form.lastName"
                            :rules="rules.lastName"
                            :label="$t('auth.labels.lastName')"
                            required
                          />
                        </v-col>
                      </v-row>
                      <v-text-field
                        data-cy="email-provider"
                        v-model="form.email"
                        :rules="rules.email"
                        :label="$t('auth.labels.email')"
                        required
                      />
                      <v-text-field
                        data-cy="phone-provider"
                        v-model="form.phone"
                        :rules="rules.phone"
                        maxlength="10"
                        :label="$t('auth.labels.phone')"
                        required
                      />
                      <div class="d-flex justify-end">
                        <v-btn
                          data-cy="signUp-provider"
                          depressed
                          rounded
                          color="primary"
                          :disabled="!isValid"
                          @click="createAccount">
                          {{ $t('auth.labels.signUp') }}
                        </v-btn>
                      </div>
                    </v-form>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    {{ $t('auth.loginAccount') }}
                    <v-btn
                      small
                      text
                      color="primary"
                      to="/login">
                      {{ $t('auth.login') }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          <!-- </v-tab-item>
          <v-tab-item> -->
            <v-card flat v-else>
              <v-card-title>{{ $t('auth.createAccountType', {type: $t('auth.restaurant')}) }}</v-card-title>
              <v-card-text>
                <v-row>
                  <v-col>
                    <v-form v-model="isValid">
                      <v-row>
                        <v-col>
                          <v-text-field
                            v-model="form.firstName"
                            :rules="rules.firstName"
                            :label="$t('auth.labels.firstName')"
                            required
                            data-cy="firstName-restaurant"
                          />
                        </v-col>
                        <v-col>
                          <v-text-field
                            v-model="form.lastName"
                            :rules="rules.lastName"
                            :label="$t('auth.labels.lastName')"
                            required
                            data-cy="lastName-restaurant"
                          />
                        </v-col>
                      </v-row>
                      <v-text-field
                        v-model="form.email"
                        :rules="rules.email"
                        :label="$t('auth.labels.email')"
                        required
                        data-cy="email-restaurant"
                      />
                      <v-text-field
                        v-model="form.phone"
                        :rules="rules.phone"
                        :label="$t('auth.labels.phone')"
                        maxlength="10"
                        required
                        data-cy="phone-restaurant"
                      />
                      <div class="d-flex justify-end">
                        <v-btn
                          data-cy="signUp-restaurant"
                          depressed
                          rounded
                          color="primary"
                          :disabled="!isValid"
                          @click="createAccount">
                          {{ $t('auth.labels.signUp') }}
                        </v-btn>
                      </div>
                    </v-form>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    {{ $t('auth.loginAccount') }}
                    <v-btn
                      small
                      text
                      color="primary"
                      to="/login">
                      {{ $t('auth.login') }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          <!-- </v-tab-item>
        </v-tabs-items> -->
      </v-card>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'Register',

  data () {
    return {
      // tab: 0,
      showPassword: false,
      isValid: false,
      form: {
        firstName: '',
        lastName: '',
        email: '',
        phone: ''
      },
      rules: {
        firstName: [
          v => !!v || this.$t('validations.firstName'),
          v => /^[a-zA-Z0-9áéíóúÁÉÍÓÚüÜñÑ ]*$/.test(v) || this.$t('validations.alphaNumericAcentuated')
        ],
        lastName: [
          v => !!v || this.$t('validations.lastName'),
          v => /^[a-zA-Z0-9áéíóúÁÉÍÓÚüÜñÑ ]*$/.test(v) || this.$t('validations.alphaNumericAcentuated')
        ],
        email: [
          v => !!v || this.$t('validations.email.required'),
          v => /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(v) || this.$t('validations.email.valid')
        ],
        phone: [
          v => !!v || this.$t('validations.phone'),
          v => /[0-9]/.test(v) || this.$t('validations.numberValid'),
          v => v.length === 10 || 'Phone must be a 10 digits long'
        ]
      }
    }
  },
  computed: {
    isProvider () {
      return this.$route.query.provider
    }
  },
  mounted () {
    this.$store.commit('clearUserprovider')
    // this.tab = this.isProvider ? 1 : 0
  },
  methods: {
    async createAccount () {
      if (this.isValid) {
        try {
          if (this.isProvider) {
            this.$store.commit('setUserprovider')
          }
          const response = await this.$api.post('/v1/signup', this.form)
          this.$router.push({ name: 'ThankYou', params: { user: response } })
        } catch (error) {
          this.$toasted.show(error.message, { duration: 3000 })
        }
      }
    }
  }
}
</script>

<style lang="css" scoped>
</style>
